import React from 'react'
import { Button, Card } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import Layout from '../home/theme/Layout'
import { appUrl } from '../../utils'

export default function CarritoProductosSuccess() {
  const history = useHistory()

  return (
    <Layout title="Pago exitoso">
      <div className="container py-4 py-lg-5">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <Card className="shadow-sm border-0">
              <Card.Body className="d-flex flex-column align-items-center text-center py-5 px-4">
                <i className="fa fa-check-circle text-success fa-4x mb-3" />
                <h1 className="h4 mb-2 fw-bold">¡Pago realizado con éxito!</h1>
                <p className="text-muted mb-4">
                  Tu compra de productos ha sido procesada correctamente.
                </p>
                <div className="d-flex flex-column flex-sm-row gap-2">
                  <Button
                    variant="primary"
                    onClick={() => history.push(appUrl({ url: '/productos' }))}
                  >
                    Seguir comprando
                  </Button>
                  <Button
                    variant="outline-secondary"
                    onClick={() => history.push(appUrl({ url: '/mis-tickets' }))}
                  >
                    Mis tickets
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </Layout>
  )
}
